import { createContext, useContext, useEffect, useState } from "react";

const ClockCtx = createContext(null);
const DEMO_KEY = "wedding_demo_time";

/**
 * Provides a "virtual now" used by Timeline / LiveBadge components.
 * Couple can toggle demo mode and pick a target time to preview how the
 * Estado en Vivo will look during the wedding day.
 */
export const ClockProvider = ({ children }) => {
  const [demoIso, setDemoIso] = useState(() => localStorage.getItem(DEMO_KEY) || null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (demoIso) localStorage.setItem(DEMO_KEY, demoIso);
    else localStorage.removeItem(DEMO_KEY);
  }, [demoIso]);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  // When demo is on, advance virtualNow at the same real-time pace so transitions
  // can be observed live without further user input.
  const baseRealRef = useState(() => Date.now())[0];
  const baseDemoMs = demoIso ? new Date(demoIso).getTime() : null;

  const getNow = () => {
    if (baseDemoMs == null) return new Date();
    const elapsed = Date.now() - baseRealRef;
    return new Date(baseDemoMs + elapsed);
  };

  // eslint-disable-next-line no-unused-vars
  const _ = tick; // depend on tick so consumers re-render every second

  return (
    <ClockCtx.Provider value={{
      now: getNow(),
      demoOn: !!demoIso,
      demoIso,
      setDemoIso: (iso) => setDemoIso(iso),
      clearDemo: () => setDemoIso(null),
    }}>
      {children}
    </ClockCtx.Provider>
  );
};

export const useClock = () => useContext(ClockCtx);
